import { render, staticRenderFns } from "./vpd-custom-dialog.vue?vue&type=template&id=162e72b4&scoped=true"
import script from "./vpd-custom-dialog.vue?vue&type=script&lang=js"
export * from "./vpd-custom-dialog.vue?vue&type=script&lang=js"
import style0 from "./vpd-custom-dialog.vue?vue&type=style&index=0&id=162e72b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e72b4",
  null
  
)

export default component.exports